import { render, staticRenderFns } from "./ForcePasswordReset.vue?vue&type=template&id=2543a4d7&scoped=true"
import script from "./ForcePasswordReset.vue?vue&type=script&lang=js"
export * from "./ForcePasswordReset.vue?vue&type=script&lang=js"
import style0 from "./ForcePasswordReset.vue?vue&type=style&index=0&id=2543a4d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543a4d7",
  null
  
)

export default component.exports